<template>
    <div class="content-mobile">
       <div v-if="success=='true'">
           <div class="top-mobile">
               <p class="price">￥{{price}}</p>
               <p class="countDown">
                   支付剩余时间：{{countNumber}}
               </p>
           </div>
           <div class="bottom-mobile">
               <p class="payWay">选择支付方式</p>
               <p class="clear alipay" @click="chooseType('alipay')" v-if="!WeiXin"><span :class="type=='alipay'?'chose':''"><img :src="type=='alipay'?require('../../assets/img/mobile/alipay.png'):require('../../assets/img/mobile/alipaygray.png')" alt="">支付宝</span><img :src="type=='alipay'?require('../../assets/img/mobile/selected.png'):require('../../assets/img/mobile/unselect.png')" alt="" class="choose"></p>
               <p class="clear" @click="chooseType('wx')"><span :class="type=='wx'?'chose':''"><img :src="type=='wx'?require('../../assets/img/mobile/wx.png'):require('../../assets/img/mobile/wxgray.png')" alt="">微信</span><img :src="type=='wx'?require('../../assets/img/mobile/selected.png'):require('../../assets/img/mobile/unselect.png')" alt="" class="choose"></p>
           </div>
           <div class="btn" @click="paySure" v-if="!hasPay">
               <span>确认支付</span><img src="../../assets/img/mobile/right.png" alt="">
           </div>
           <div class="btn hasPay" v-else>
               <span>确认支付</span><img src="../../assets/img/mobile/right.png" alt="">
           </div>
       </div>
        <div class="error-mobile">
            <div v-if="success=='false'">
                <div class="error-content">
                    <img src="../../assets/img/mobile/warning.png" alt="">
                    <p>支付异常</p>
                    <p class="error-tips">非法参数，点击下方返回收银台重新支付</p>
                </div>
                <div class="error-btn" @click="goBack">
                    返回收银台
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "payMobile",
        data () {
            return {
                countNumber:'',
                type:'alipay',
                orderId:'',
                site:'',
                name:'',
                price:'',
                addressInfo:'',
                requestBool:false,
                timeInterval:'',
                businessType:'',
                notifyUrl:'',
                payWay:'',
                tradeType:'',
                url:'',
                indexUrl:'',  // 支付失败跳转首页
                openId:'',
                success:'true',
                hasPay:false,
                WeiXin:false,
            }
        },
        methods: {
            chooseType(type){
                this.type = type;
            },
            goBack(){
              this.$router.go(-1);
            },
            isWeiXin() {
                const ua = window.navigator.userAgent;
                if (ua.indexOf('MicroMessenger')>0) {
                    return true;
                }else{
                    return false;
                }
            },
            paySure(){
                const me = this;
                if(this.type =='wx'){  // 微信支付
                    let successUrl = `/payResultMobile.html&&success==true&&url=${this.url}&&price=${this.price}&&orderId=${this.orderId}`;
                    let failUrl = `/payResultMobile.html&&success==false`;
                    if(this.isWeiXin()){
                        this.tradeType = 'JSAPI';
                    }else{
                        this.tradeType = 'MWEB';
                    }
                    this.payWay = '微信支付';
                    //content-mobile 微信内支付
                    if(me.isWeiXin()){
                        me.request('/common/pay/getShortStateParam.json', {
                            data:{
                                longParam: window.btoa(this.$route.fullPath),
                            }
                        }).then((res) => {
                            if(res.flag){
                                if(me.$route.query.wxAuthId){

                                }else{
                                    let redirectUrl = 'https://pay.datacastle.cn/api/common/pay/wxAuth.json';
                                    window.location.href =
                                        'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe4dbb7e81d0db4aa&redirect_uri='+ redirectUrl +'&response_type=code&scope=snsapi_base&state=' +
                                        res.data.shortParam +
                                        '#wechat_redirect';
                                }
                            }

                        })
                    }else{
                        this.request('/common/pay/preCreateOrder.json', {
                            method:'post',
                            data:{
                                orderId:this.orderId,
                                payWay:this.payWay,
                                site:this.site,
                                tradeType:this.tradeType,
                            }
                        }).then((res) => {
                            if(res.flag){
                                // 微信外支付
                                window.location.href = res.data.orderLog.preCreateResponse.mwebUrl;
                                // window.location.href = res.data.orderLog.preCreateResponse.mwebUrl + '&redirect_url=' + encodeURIComponent(this.url);
                            }
                        })
                    }
                }else{  // 支付宝支付
                    this.payWay = '支付宝支付';
                    this.tradeType = 'MWEB';
                    window.location.href = '/api/common/pay/preCreateOrder.json?orderId=' + this.orderId + '&payWay=' + this.payWay + '&site=' + this.site + '&tradeType=' + this.tradeType
                }

            },
            getPayStatus(){
                const me = this;
                this.request('/common/pay/checkOrderPayStatus.json', {
                    method:'get',
                    data:{
                        orderId:this.orderId,
                        payWay:'微信支付',
                    }
                }).then((res) => {
                    if(res.data.isPaid){
                        window.location.href = this.url;
                    }else{
                        setTimeout(function () {
                            me.getPayStatus();
                        },3000)
                    }
                });
            },
            countdown(val) {
                let lastTime = val;
                this.timeInterval = window.setInterval(() => {
                    lastTime = lastTime - 1000;
                    if (this.common.lastTime(lastTime)) {
                        this.countNumber = this.common.lastTime(lastTime);
                    } else {
                        clearInterval(this.timeInterval);
                        this.$router.push({path:'/payResultMobile.html',query:{success:'time',indexUrl:this.indexUrl}});
                    }
                    this.requestBool = true;
                }, 1000)

            }
        },
        mounted: function () {
            if(this.isWeiXin()){
                this.WeiXin = true;
                this.type = 'wx';
            }else{
                this.WeiXin = false;
            }
            if(this.$route.query.orderId){
                this.orderId = this.$route.query.orderId;
            }
            if(this.$route.query.site){
                this.site = this.$route.query.site;
            }
            if(this.$route.query.wxAuthId){
                this.hasPay = true;
                this.type = 'wx';
            }

            this.request('/common/pay/getPayInfo.json', {
                data:{
                    orderId: this.orderId,
                    site: this.site,
                }
            }).then((res) => {
                if(res.data.payInfo){
                    let info = JSON.parse(res.data.payInfo.orderInfo);
                    this.name = info.subject;
                    this.price = info.orderPrice;
                    this.businessType = info.businessType;
                    this.notifyUrl = res.data.payInfo.notifyUrl;
                    this.site = res.data.payInfo.site;
                    this.indexUrl = res.data.payInfo.indexUrl;
                    this.url = res.data.payInfo.returnUrl;
                    if(res.data.payInfo.leftMillisSecondsTime>0){
                        this.countdown(res.data.payInfo.leftMillisSecondsTime);
                    }else{
                        this.$router.push({path:'/payResultMobile.html',query:{success:'time',indexUrl:this.indexUrl}});
                    }
                }else{
                    this.success = 'false';
                }
                // 判断是否支付
               this.getPayStatus();
                if (this.$route.query.wxAuthId) {
                    this.openId = this.$route.query.wxAuthId;
                    this.request('/common/pay/getWxH5PaySignature.json', {
                        method:'get',
                        data:{
                            orderId:this.orderId,
                            site:this.site,
                            openId:this.openId,
                        }
                    }).then((res) => {
                        let successUrl = `/payResultMobile.html?success=true&&url=${this.url}&&price=${this.price}&&orderId=${this.orderId}`;
                        let failUrl = `/payResultMobile.html?success=false`;
                        let authObj = res.data.signInfo;
                        this.common.pay(authObj,successUrl,failUrl)
                    })

                    // this.common.pay(this.common.randomString(10,32),this.$route.query.wxAuthId,successUrl,failUrl)
                }

            })
        }
    }
</script>

<style scoped lang="scss">
    .content-mobile{
        .top-mobile{
            background: #fff;
            margin-bottom: 0.2rem;
            padding-top: 1.38rem;
            .price{
                text-align: center;
                margin-bottom: 0.2rem ;
                font-size:0.48rem;
                font-weight:normal;
                color:rgba(255,66,0,1);
                line-height:0.47rem;
            }
            .countDown{
                text-align: center;
                font-size:0.28rem;
                font-weight:400;
                color:rgba(153,153,153,1);
                line-height:0.4rem;
                padding-bottom: 0.5rem;
            }
        }
        .bottom-mobile{
            background: #fff;
            text-align: left;
            padding: 0.2rem 0 0 0.3rem;
            font-size:0.28rem;
            font-weight:400;
            color:rgba(153,153,153,1);
            line-height:0.4rem;
            .payWay{
                height: 0.8rem;
                line-height: 0.8rem;
                border-bottom: 1px solid rgba(0,0,0,0.08);
                box-sizing: border-box;
            }
            p{
                height: 1rem;
                line-height: 1rem;
                box-sizing: border-box;
                span{
                    float: left;
                    display: flex;
                    align-items: center;
                    img{
                        width: 0.36rem;
                        height: 0.36rem;
                        margin-right: 0.16rem;
                    }
                    &.chose{
                        color:#333;
                    }
                }
                .choose{
                    float: right;
                    width: 0.36rem;
                    height: 0.36rem;
                    margin-right: 0.3rem;
                    margin-top: 0.32rem;
                }
                &.alipay{
                    border-bottom: 1px solid rgba(0,0,0,0.08);
                }
            }
        }
        .btn{
            width: 100%;
            height: 0.97rem;
            background:rgba(28,140,254,1);
            display: flex;
            align-items: center;
            justify-content: center;
            position: fixed;
            bottom: 0;
            img{
                margin-left:0.17rem;
                width: 0.36rem;
                height: 0.25rem;
            }
            span{
                font-size:0.3rem;
                font-weight:500;
                color:rgba(255,255,255,1);
                line-height:0.42rem;
            }
            &.hasPay{
                background: #cccccc;
            }
        }
        .error-mobile{
            padding: 1.08rem 0.3rem 0 0.3rem;
            .error-content{
                text-align: center;
                font-size:0.4rem;
                font-weight:500;
                color:rgba(48,50,51,1);
                img{
                    width: 1.66rem;
                    height: 1.66rem;
                    margin-bottom: 0.06rem;
                }
                .error-tips{
                    font-size:0.24rem;
                    font-weight:400;
                    color:rgba(153,153,153,1);
                    margin-top: 0.2rem;
                    margin-bottom: 0.57rem;
                }
            }
            .error-btn{
                width: 100%;
                height: 0.96rem;
                background:rgba(28,140,254,1);
                border-radius:0.06rem;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size:0.3rem;
                font-weight:500;
                color:rgba(255,255,255,1);
            }
        }

    }
</style>
